import React, { useState } from "react";
import heroImg from "../arktemis media/WhatsApp Image 2025-04-24 at 17.52.38_00138d70.jpg";
// import "./Bootstraphome.css"; // Removed: all styles will be Tailwind
import { cards, services } from "./homeData";
import pdf from "../arktemis media/arkpdf.pdf";
import { posts } from './postsData'; // Import posts
import { Link } from 'react-router-dom'; // Import Link for navigation

const Bootstraphome = () => {
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const videoSrc = "/websitevid.mp4";

  /* ---------- helper: open/close the off‑canvas ---------- */
  const toggleOffCanvas = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
    document.body.style.overflow = isOffCanvasOpen ? "auto" : "hidden";
  };

  // Get the two most recent posts
  const recentPosts = posts.slice(0, 2);

  /* ========================================================= */
  return (
    <div className="flex flex-col w-full bg-black">
      {/* ── HERO VIDEO ───────────────────────────────────────── */}
      <section className="relative w-full min-h-screen text-white flex items-center justify-center bg-black py-20 px-4">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover brightness-50"
          src={videoSrc}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster="/favicon.ico"
          aria-label="Arktemis home page background video"
          onPlay={() => window.gtag?.('event', 'video_play', { event_category: 'video', event_label: 'home_page_video' })}
        />

        <div
          className="relative z-10 mx-auto bg-black bg-opacity-70 backdrop-blur-md p-10 rounded-xl text-center max-w-6xl border border-gray-700"
          data-aos="fade-up"
        >
          <h1 className="font-extrabold text-5xl md:text-7xl leading-tight mb-6 tracking-tight bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
            Pioneering the Future of Sustainable Resource Management
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed text-gray-300">
            At Arktemis, we engineer holistic solutions that balance ecological health with human prosperity. Leveraging advanced geospatial
            intelligence, precision agriculture, and cyber-physical systems, our science-driven methodology transforms raw data into decisive
            action.
          </p>
          <a
            href="https://www.youtube.com/watch?v=jcXh9WJFJIs"
            target="_blank"
            rel="noopener noreferrer"
            className="relative inline-flex items-center justify-center p-1 overflow-hidden text-lg font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 transition-all duration-300 ease-in-out transform hover:scale-105 active:scale-95"
          >
            <span className="relative px-10 py-4 transition-all ease-in duration-150 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
              Discover How We Work
            </span>
          </a>
        </div>
      </section>

      {/* ── RECENT POSTS SECTION ──────────────────────────────── */}
      {recentPosts.length > 0 && (
        <section className="w-full bg-black-900 py-20 px-4 border-b border-gray-800">
          <div className="container mx-auto text-white" data-aos="fade-up">
            <h2 className="text-4xl md:text-6xl font-extrabold text-center mb-16 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">Featured Insights</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              {recentPosts.map((post) => (
                <div key={post.id} className="relative h-96 rounded-xl shadow-2xl overflow-hidden group border border-gray-700"
                  style={{
                    backgroundImage: `url(${post.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  <div className="absolute inset-0 bg-black bg-opacity-75 backdrop-blur-md flex flex-col justify-end p-10
                              group-hover:bg-opacity-90 transition-all duration-300">
                    <h3 className="text-3xl md:text-4xl font-bold mb-4 leading-tight text-white text-shadow-lg">
                      <Link to={`/posts/${post.id}`} className="hover:text-blue-400 transition-colors duration-300">
                        {post.title}
                      </Link>
                    </h3>
                    <p className="text-gray-300 text-lg md:text-xl mt-4">Read the full article &rarr;</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}


      {/* ── ABOUT ARKTEMIS FOUNDATION SECTION ────────────────────────────────────── */}
      <section className="relative w-full bg-black py-20 px-4 text-white flex items-center justify-center border-b border-gray-800">
        <img
          src={heroImg}
          alt="Arktemis Foundation background"
          className="absolute top-0 left-0 w-full h-full object-cover brightness-50"
        />

        <div
          className="relative z-10 mx-auto bg-black bg-opacity-70 backdrop-blur-md p-10 rounded-xl text-center max-w-6xl border border-gray-700"
          data-aos="fade-up"
        >
          <p className="text-xl md:text-2xl leading-relaxed mb-8 text-gray-300">
            Arktemis Foundation is a systems‑based research company specializing in
            sustainable resource management. We build resilient frameworks to
            tackle complex challenges in resource modeling, precision
            agriculture, water management and more. Using our proprietary
            systems approach, we deliver solutions that are both economically
            and environmentally sustainable.
          </p>

          <button
            className="relative inline-flex items-center justify-center p-1 overflow-hidden text-lg font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 transition-all duration-300 ease-in-out transform hover:scale-105 active:scale-95"
            type="button"
            onClick={toggleOffCanvas}
          >
            <span className="relative px-10 py-4 transition-all ease-in duration-150 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
              Core Capabilities
            </span>
          </button>
        </div>

      </section>


      <div className="w-full bg-black-900 py-20 px-4 border-b border-gray-800">
        <div className="container mx-auto" data-aos="fade-up">
          <h2 className="text-4xl md:text-6xl font-extrabold text-center mb-16 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">Our Focus Areas</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {cards.map((card, index) => (
              <div className="col-span-1 group" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div
                  className="relative h-80 rounded-xl shadow-2xl overflow-hidden border border-gray-700 transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-2xl group-hover:shadow-blue-500/50"
                  style={{
                    backgroundImage: `url(${card.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex flex-col justify-end p-8
                              group-hover:bg-opacity-80 transition-all duration-300">
                    <h4 className="text-2xl font-bold text-white mb-2">{card.title}</h4>
                    <p className="text-gray-300 text-base mb-4">{card.description}</p>
                    <a href="/arktemispage" className="relative inline-flex items-center justify-center p-0 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800">
                      <span className="relative inline-flex items-center justify-center p-1.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800">
                        Explore &rarr;
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* ── OFF‑CANVAS ───────────────────────────────────────── */}
      <div
        className={`fixed top-0 left-0 h-full w-full sm:w-80 bg-black text-white transform ${isOffCanvasOpen ? "translate-x-0" : "-translate-x-full"}
                   transition-transform duration-300 ease-in-out z-[1050] overflow-y-auto`}
      >
        <div
          className="flex justify-center relative p-6 border-b border-gray-700"
        >
          <button
            type="button"
            className="absolute left-6 top-6 text-white text-3xl bg-transparent border-2 border-white rounded-full w-10 h-10 flex items-center justify-center
                       hover:bg-white hover:text-black transition-colors duration-300"
            onClick={toggleOffCanvas}
          >
            &times;
          </button>

          <h5
            className="text-2xl font-semibold text-white text-center mt-2"
          >
            Our Core Capabilities
          </h5>
        </div>

        {/* ---------- thumbnails ---------- */}
        <div className="p-6 space-y-6">
          {services.map((srv, i) => (
            <Link to={srv.route} key={i} onClick={() => {
              setIsOffCanvasOpen(false);
              document.body.style.overflow = "auto";
            }}>
              <div
                className="relative cursor-pointer group rounded-xl shadow-lg overflow-hidden border border-gray-700"
                role="button"
              >
                <img src={srv.img} className="w-full h-48 object-cover brightness-75 group-hover:brightness-100 transition-all duration-300" alt={srv.alt} />
                <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center p-4 rounded-xl
                            group-hover:bg-opacity-80 transition-opacity duration-300">
                  <p className="text-white text-xl font-semibold text-center">{srv.alt}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <div className="text-center py-12">
        <a
          href= {pdf}
          download
          className="relative inline-flex items-center justify-center p-1 overflow-hidden text-lg font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 transition-all duration-300 ease-in-out transform hover:scale-105 active:scale-95"
          data-aos="fade-up"
        >
          <span className="relative px-12 py-5 transition-all ease-in duration-150 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
            Download PDF
          </span>
        </a>
      </div>
    </div>
  );
};

export default Bootstraphome;
